<template>
    <!-- 登录页面 -->
    <div style="width: 100%; margin-top: 200px; margin-bottom: 400px; height: auto;">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

            <div style="width: 600px; margin:0 auto;" align="center">
                <el-form-item label="账号" prop="zh">
                    <el-input type="zh" v-model="ruleForm.zh" autocomplete="off"></el-input>
                </el-form-item>
            </div>
            

            <div style="width: 600px; margin:0 auto" align="center">
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
            </div>

            <div v-show="condition" style="width: 600px;  margin:0 auto" align="center">
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                </el-form-item>
            </div>
            
            <!-- <div v-show="condition" style="width: 600px; background-color: #E9F0F3; margin:0 auto" align="center">
                <el-form-item label="年龄" prop="age">
                    <el-input v-model.number="ruleForm.age"></el-input>
                </el-form-item>
            </div> -->
            <div style="text-align: center; font-size: 15px; color:red"> {{error_message}} </div>

            <div style="width: 600px; margin:0 auto" >
                <el-form-item >
                    <!-- <el-button type="primary">提交</el-button> -->
                    <el-button type="primary" @click.prevent="zhuce">前往{{info}}</el-button>
                    <!-- <el-button type="primary" @click.prevent="submitForm">{{info1}}</el-button> -->
                    <!-- <el-button type="primary" :plain="true" @click.prevent="submitForm">{{info1}}</el-button> -->
                    <el-button type="primary" plain @click.prevent="submitForm">{{info1}}</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </div>
            

        </el-form>
    </div>
    
</template>

<script>
    import { mapState, mapGetters ,mapMutations, mapActions} from 'vuex'
    import $ from 'jquery'
    export default {
    data() {
      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('年龄不能为空'));
        }
      };
      var validatezh = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          if (this.ruleForm.zh !== '') {
            this.$refs.ruleForm.validateField('checkzh');
          }
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        error_message:"",
        condition:false,
        info:'注册',
        info1:'登录',
        ruleForm: {
          zh:'',
          pass: '',
          checkPass: '',
          age: ''
        },
        rules: {
          zh:[
            { validator: validatezh, trigger: 'blur'}
          ],
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          age: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      zhuce() { // 这里是切换是登录还是注册
        if (this.condition === false) {
            this.ruleForm.zh = ''
            this.ruleForm.pass = ''
            /* 清空 */

            this.condition = true
            this.info = '登录'
            this.info1 = '提交'
        }
        else {
            this.ruleForm.zh = ''
            this.ruleForm.pass = ''
            /* 清空 */

            this.condition = false
            this.info = '注册'
            this.info1 = '登录'
        }
        
      },
      submitForm() { // 提交账号密码信息
        const store = this.$store
        const router = this.$router
        const vue = this
        const zhuce = this.zhuce

        if(this.ruleForm.zh === "") {
          vue.$notify({
            message: '账号没有输入',
            type: 'success',
            offset: 100,
            duration: 2000,
          });
          return
        } 
        if(this.ruleForm.pass === "") {
          vue.$notify({
            message: '密码没有输入',
            type: 'success',
            offset: 100,
            duration: 2000,
          });
          return
        } 
      
        if (this.info === '注册') { // 说明是登录
          store.dispatch("login", {
            username: this.ruleForm.zh,
            password: this.ruleForm.pass,
            success() {
              store.dispatch("getinfo", {
                success() {
                  vue.$notify({
                    message: '登录成功',
                    type: 'success',
                    offset: 100,
                    duration: 2000,
                  });
                  vue.error_message = "" // 清空报错信息
                  router.push('/homepage');
                }
              })
            },
            error() {
              console.log(this.error_message)
              vue.error_message = "用户名或密码错误" // 清空报错信息
              vue.$notify({
                message: '登录失败',
                type: 'warning',
                offset: 100,
                duration: 2000,
              });
            }
          })
        } 
        else if (this.info === '登录') { // 说明是注册
          let username = this.ruleForm.zh
          let password = this.ruleForm.pass
          let confirmedPassword = this.ruleForm.checkPass

          $.ajax({
            url: 'https://app6132.acapp.acwing.com.cn/api/user/account/register/',
            type: 'post',
            data: {
              username: username,
              password: password,
              confirmedPassword: confirmedPassword,
            },
            success(resp) {
              if (resp.error_message === 'success') {
                  console.log("我成功注册了")
                  vue.error_message = "" // 清空报错信息
                  vue.$notify({
                    message: '注册成功，已跳转到登录页面',
                    type: 'success',
                    offset: 100,
                    duration: 2000,
                  });
                  zhuce()
              } else {
                  vue.$notify({
                      message: '注册失败',
                      type: 'warning',
                      offset: 100,
                      duration: 2000,
                    });
                  vue.error_message = resp.error_message
                  console.log(this.error_message)
              }
            },
            error(resp) {
              console.log(resp)
            }
          })
        }
      },
      resetForm(formName) { // 重置表单信息 不需要修改
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style scoped>

</style>